
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NoteBox extends Vue {
    @Prop({required: false, default: '8pt'})
    fontSize?: string;

    @Prop({required: false, default: '0px'})
    borderRadius?: string;

    @Prop({required: false, default: '0px'})
    border?: string;
}
